import {Component, OnInit} from '@angular/core';
import { BizService } from 'src/app/services/biz.service';
import { SecurityService } from 'src/app/services/security.service';
import {MenuService} from "../../../services/menu-service";

@Component({
    selector: 'app-user-login',
    templateUrl: './user-login.component.html',
    styleUrls: ['./user-login.component.css'],
    standalone: false
})
export class UserLoginComponent implements OnInit {

  validPassword = true;
  loginAttempted = false;
  loading = false;

  constructor(private bizService: BizService,
    private securityService: SecurityService,
    private menuService : MenuService) {
}

  userName: string = "";
  password: string = "";

  ngOnInit(): void {
    this.securityService.loginChangedEventEmitter.subscribe(() => {
      this.loading = false;
      this.loginAttempted = true;
    });
  }

  async UserLogin()
  {
    this.loginAttempted = false;
    this.loading = true;
    this.validPassword = await this.bizService.UserLogin(this.userName, this.password);
    if(this.validPassword)
    {
      // alert('IN UserLogin() - this.validPassword = true');
      this.menuService.SetActiveMenuName('Home');
      this.userName = "";
      this.password = "";
    }
  }

}
